import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders , HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import * as CryptoJS from 'crypto-js';

import { UrlConstant } from './constants/url-constant';
import { GlobalConstant } from './constants/global-constant';
import { AppData } from './constants/app-data';

@Injectable({
  providedIn: 'root'
})

//reference: https://www.techiediaries.com/handle-angular-9-8-7-httpclient-errors-with-rxjs-catcherror-and-throwerror/

export class DataService {
  	static r;
  	
  	constructor(private router: Router, private httpClient: HttpClient, private appData: AppData) { DataService.r = router; }
  	
  	public getShallowClone(sourceData){
		return Object.assign({}, sourceData);
	}
	  
  	public async getLoggedInUserData(reqBody){
  		//var reqBody = {"userId":username } OR { };
  		reqBody.token =  this.getApiKeyHeaderFromLocalStorage();
  		//var reqBody = {"userId":username, 'token': token };
  		
  		//waits for the call response
  		await this.sendPostRequestWithBody(UrlConstant.apiGetLoggedInUserData, reqBody).toPromise().then((data: any)=>{
  			//console.log(data);
  			if("SUCCESS" === data.status){
				this.appData.loginSuccessToken = reqBody.token;
	  			this.appData.userId = data.data.loginUserId;
	  			this.appData.user.next(data.data);
	  			this.appData.loginInvalid.next(false);
	  			this.appData.isAuthenticated.next(true);
	  			this.appData.isLeftNavActive.next(true);
	  			this.appData.leftNavMenuDrawer.subscribe(leftMenuDrawer=> leftMenuDrawer.open());
	  			
	  			//data.data.firstName;
	  			//data.data.lastName;
	  			
	  			//Get Privileges from back-end
	  			//this.getLoggedInUserAllPrivileges(reqBody);
  			}
  		});
  		//console.log('...getLoggedInUserData....');
  	}
  	
  	public async getLoggedInUserRolesOrPrivileges(reqBody, rolePrev){
  		//var reqBody = {"userId":username } OR { };
  		reqBody.token =  this.getApiKeyHeaderFromLocalStorage();
  		//var reqBody = {"userId":username, 'token': token };
  		var reqUrl = (rolePrev === 'ROLE')? UrlConstant.apiGetLoggedInUserAllRoles : (rolePrev === 'PRIV'? UrlConstant.apiGetLoggedInUserAllPrivileges : '' );
  		await this.sendPostRequestWithBody(reqUrl, reqBody).toPromise().then((data: any)=>{
  			//console.log("getLoggedInUserAllPrivileges::"+data);
  			if("SUCCESS" === data.status){
  				if(rolePrev === 'ROLE')
  					this.appData.allRoles.next(data.data);
  				else
	  				this.appData.allPrivileges.next(data.data);
  			} else {
  				if(rolePrev === 'ROLE')
  					this.appData.allRoles.next(data.data);
  				else
  					this.appData.allPrivileges.next(data.data);
  			}
  		});
  		//console.log('...getLoggedInUserAllPrivileges....');
  	}
  	
  	
  	public async getLoggedInUserDataWithAllPrivileges(reqBody){
  		//var reqBody = {"userId":username } OR { };
  		reqBody.token =  this.getApiKeyHeaderFromLocalStorage();
  		//var reqBody = {"userId":username, 'token': token };
  		
  		//waits for the call response
  		await this.sendPostRequestWithBody(UrlConstant.apiGetLoggedInUserDataWithAllPrivileges, reqBody).toPromise().then((data: any)=>{
  			//console.log("--getLoggedInUserDataWithAllPrivileges--"+data);
  			var obj = {};
  			if("SUCCESS" === data.status && data.data.userData !== undefined){
	  			this.appData.userId = data.data.userData.loginUserId;
	  			this.appData.loginSuccessToken = reqBody.token;
	  			
	  			//Setting User Data
	  			this.appData.user.next(data.data.userData);
	  			//data.data.userData.firstName;
	  			//data.data.userData.lastName;
	  			
	  			this.appData.loginInvalid.next(false);
	  			this.appData.isAuthenticated.next(true);
	  			this.appData.isLeftNavActive.next(true);
	  			this.appData.leftNavMenuDrawer.subscribe(leftMenuDrawer=> leftMenuDrawer.open());
	  			
	  			//Setting All Privileges
	  			this.appData.allPrivileges.next(data.data.userAllPriv);
	  			data.data.userAllPriv.forEach((element) => {obj[element.id] = true});
	  			this.appData.availablePrivileges.next(obj);
  			} else {
				//make it blank
				this.appData.availablePrivileges.next(obj);
				this.appData.isAuthenticated.next(false);
	      		this.appData.isLeftNavActive.next(false);
	      		this.appData.leftNavMenuDrawer.subscribe(leftMenuDrawer=> leftMenuDrawer.close());
	      		
	      		this.removeApiKeyHeaderFromLocalStorage();
			}
  		});
  		
  		//load the Roles also
  		this.getLoggedInUserRolesOrPrivileges(reqBody, 'ROLE');
  		
  		//console.log("------getLoggedInUserDataWithAllPrivileges--");
  	}
  	public async logout(loginUrlToRedirect){
		var reqBody = {"userId": this.appData.userId};
  		this.sendPostRequestWithBody(UrlConstant.apiLogout ,reqBody).subscribe((data: any)=>{
	      //console.log(data);
	      if("SUCCESS" === data.statusCode){
	      		this.updateUIWithLogoutData(loginUrlToRedirect);
	      }
	    });
	}
	
	public updateUIWithLogoutData(loginUrlToRedirect){
		//this.appData.loginInvalid.next(true);
  		this.appData.userId = "";
  		this.appData.isAuthenticated.next(false);
  		this.appData.isLeftNavActive.next(false);
  		this.appData.leftNavMenuDrawer.subscribe(leftMenuDrawer=> leftMenuDrawer.close());
  		this.removeApiKeyHeaderFromLocalStorage();
  		if(loginUrlToRedirect != undefined && loginUrlToRedirect != null && loginUrlToRedirect != '')
  			this.navigateToUrl('/'+loginUrlToRedirect);
  		else{
			var uId = this.getFromLocalStorage(GlobalConstant.KEY_LOCAL_STORAGE_VENDOR_UNIQUE_ID);
			if(uId!=null && uId != undefined && uId!=''){
				var param ={};
		    	param[GlobalConstant.KEY_URL_PARAM_VENDOR_UNIQUE_ID] = uId; 
		    	DataService.r.navigate(['/home', param]);
			} else
  				this.navigateToUrl('/home');
  		}	
	}
	
	public redirectIfSessionaExpired(data){
		if(data.status == 'EXPIRED_SESSION'){
			this.updateUIWithLogoutData('');
			return true;
		}
		return false;
	}
	
	public async getStaticData(reqBody){
  		//var reqBody = {"userId":username } OR { };
  		reqBody.token =  this.getApiKeyHeaderFromLocalStorage();
  		//var reqBody = {"userId":username, 'token': token };
  		
  		//waits for the call response
  		await this.sendPostRequestWithBody(UrlConstant.apiGetStaticData, reqBody).toPromise().then((data: any)=>{
  			//console.log("--getStaticData--"+data);
  			if("SUCCESS" === data.status){
	  			//this.appData.availablePrivileges.next(obj);
	  			let testSerUrl = data.data['test-series-url'];
	  			testSerUrl = this.encryptUsingAES256(testSerUrl, null);
	  			//console.log("--getStaticData--enc:" + testSerUrl);
	  			this.setToLocalStorage(GlobalConstant.KEY_TEST_SERIES_URL_ENC,  testSerUrl);
  			}
  		});
  		//console.log("------getStaticData--");
  	}
  	
  	public setToLocalStorage(key, value){
  		localStorage.setItem(key, value);
  	}
  	public setApiKeyHeaderToLocalStorage(apiHeaderData){
  		localStorage.setItem(this.appData.keyApiKeyHeader, apiHeaderData);
  	}
  	public removeFromLocalStorage(key){
  		localStorage.removeItem(key);
  	}
  	public removeApiKeyHeaderFromLocalStorage(){
  		localStorage.removeItem(this.appData.keyApiKeyHeader);
  	}
  	public getFromLocalStorage(key){
  		let data = localStorage.getItem(key);
  		if(data === undefined || data === null)
  			data ="";
  		return data;
  	}
  	public getObjectFromLocalStorage(key){
  		return localStorage.getItem(key);
  	}
  	public getApiKeyHeaderFromLocalStorage(){
  		let data = localStorage.getItem(this.appData.keyApiKeyHeader);
  		if(data === undefined || data === null)
  			data ="";
  		return data;
  	}
  	
  	
  	public navigateToUrl(url:string){
  		DataService.r.navigate([url]);
  	}
  	
  	// Response must be TEXT format
  	public sendGetRequestWithTextResponse(url:string){
		//return this.httpClient.get(this.config.urls.url("albums"),{ withCredentials: true });
		var headers = new HttpHeaders().set(this.appData.keyApiKeyHeader, this.getApiKeyHeaderFromLocalStorage());
	    return this.httpClient.get(url, {responseType: 'text', headers: headers});
	}
	// Response must be blob format
	public sendGetRequestWithBlobResponse(url:string, resType:string){
		//return this.httpClient.get(this.config.urls.url("albums"),{ withCredentials: true });
		var headers = new HttpHeaders().set(this.appData.keyApiKeyHeader, this.getApiKeyHeaderFromLocalStorage());
		var options;
		if(resType==='blob')
			options = {responseType: 'blob', headers: headers};
		else if(resType==='html')
			options = {responseType: 'html', headers: headers};
	    return this.httpClient.get(url, options);
	}
	// Response must be JSON format
	public sendGetRequest(url:string){
		//return this.httpClient.get(this.config.urls.url("albums"),{ withCredentials: true });
		var headers = new HttpHeaders().set(this.appData.keyApiKeyHeader, this.getApiKeyHeaderFromLocalStorage());
	    return this.httpClient.get(url, {headers}).pipe(catchError(this.handleError));
	}
	
	// Response must be JSON format
	public sendPostRequest(url:string){
		//const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
		//return this.httpClient.get(this.config.urls.url("albums"),{ withCredentials: true });
	    //return this.httpClient.post(this.REST_API_SERVER_LOGIN, {}, { headers, responseType: 'json'});
	    var headers = new HttpHeaders().set(this.appData.keyApiKeyHeader, this.getApiKeyHeaderFromLocalStorage());
	    return this.httpClient.post(url,{headers}).pipe(catchError(this.handleError));
	}
	public sendPostRequestWithBody(url:string, requestBody:any){
		//const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
		//return this.httpClient.get(this.config.urls.url("albums"),{ withCredentials: true });
	    //return this.httpClient.post(this.REST_API_SERVER_LOGIN, {}, { headers, responseType: 'json'});
	    //let headers = new HttpHeaders().set('apiKeyHeader', this.appData.loginSuccessToken);
	    var headers = new HttpHeaders().set(this.appData.keyApiKeyHeader, this.getApiKeyHeaderFromLocalStorage());
	    return this.httpClient.post(url, requestBody, {headers, responseType: 'json'}).pipe(catchError(this.handleError));
	}
	public sendPostRequestWithBodyOnPipe(url:string, requestBody:any){
		//const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
		//return this.httpClient.get(this.config.urls.url("albums"),{ withCredentials: true });
	    //return this.httpClient.post(this.REST_API_SERVER_LOGIN, {}, { headers, responseType: 'json'});
	    //let headers = new HttpHeaders().set('apiKeyHeader', this.appData.loginSuccessToken);
	    var headers = new HttpHeaders().set(this.appData.keyApiKeyHeader, this.getApiKeyHeaderFromLocalStorage());
	    return this.httpClient.post(url, requestBody, {headers, responseType: 'json'});//.pipe(catchError(this.handleError));
	}
	
	  public handleErrorWithPopup(error: HttpErrorResponse) {
	    let errorMessage = 'Unknown error!';
	    if (error.error instanceof ErrorEvent) {
	      // Client-side errors
	      errorMessage = `Error: ${error.error.message}`;
	    } else {
	      // Server-side errors
	      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
	    }
	    window.alert(errorMessage);
	    return throwError(errorMessage);
	  } 
	  public handleError(error: HttpErrorResponse) {
	    let errorMessage = 'Unknown error!';
	    if(error.error !== undefined && error.error !== null && error.error.text === 'redirectToLogin'){
	    	//this.router was not accessible here so made r as static
	    	DataService.r.navigate(['/login']);
	    	return throwError(errorMessage);
	    } else if (error.error instanceof ErrorEvent) {
	      // Client-side errors
	      errorMessage = `Error: ${error.error.message}`;
	    } else {
	      // Server-side errors
	      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
	    }
	    console.log(errorMessage);
	    console.log(error);
	    return throwError(errorMessage);
	  }
	  
///// Encryption  / Decryption related code
	tokenFromUI: string = "0123456789123456";
	public encryptUsingAES256(dataToEncrypt, salt) {
		if(salt === undefined || salt === null){
			salt = this.getApiKeyHeaderFromLocalStorage();
		}
	    let _key = CryptoJS.enc.Utf8.parse(salt);
	    let _iv = CryptoJS.enc.Utf8.parse(salt);
	    //JSON.stringify(dataToEncrypt);
	    let encrypted = CryptoJS.AES.encrypt(
	      dataToEncrypt, _key, {
	        keySize: 16,
	        iv: _iv,
	        mode: CryptoJS.mode.ECB,
	        padding: CryptoJS.pad.Pkcs7
	      });
	    return encrypted.toString();
    }
    
    public decryptUsingAES256(dataToDecrypt, salt) {
    	if(salt === undefined || salt === null){
			salt = this.getApiKeyHeaderFromLocalStorage();
		}
    	  // this.decrypted = CryptoJS.enc.Base64.parse(dataToDecrypt);
		   // alert(_key);
		     let _iv = CryptoJS.enc.Utf8.parse(salt);
		     let _key = CryptoJS.enc.Utf8.parse(salt);
		  //  // CryptoJS.enc.Base64.stringify(dataToDecrypt)
		
		  let decrypted = CryptoJS.AES.decrypt(
		       dataToDecrypt, _key, {
		         keySize: 16,
		         iv: _iv,
		         mode: CryptoJS.mode.ECB,
		         padding: CryptoJS.pad.Pkcs7
		       }).toString(CryptoJS.enc.Utf8);
		  return decrypted;
	  }
  	  
}
